







import { Component, Vue } from 'vue-property-decorator'
import Layout from './components/base/Layout.vue'
@Component({
    components: {
        Layout
    }
})
export default class App extends Vue {
}
